import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HipobuySpreadsheetGuide from "../pages/article/hipobuy-spreadsheet-guide/page";
import KakobuySpreadsheetGuide from "../pages/article/kakobuy-spreadsheet-guide/page";
import CSSBuySpreadsheetGuide from "../pages/article/cssbuy-spreadsheet-guide/page";
import SuperbuySpreadsheetGuide from "../pages/article/superbuy-spreadsheet-guide/page";
import OopbuySpreadsheetGuide from "../pages/article/oopbuy-spreadsheet-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/hipobuy-spreadsheet-guide",
    element: <HipobuySpreadsheetGuide />,
  },
  {
    path: "/article/kakobuy-spreadsheet-guide",
    element: <KakobuySpreadsheetGuide />,
  },
  {
    path: "/article/cssbuy-spreadsheet-guide",
    element: <CSSBuySpreadsheetGuide />,
  },
  {
    path: "/article/superbuy-spreadsheet-guide",
    element: <SuperbuySpreadsheetGuide />,
  },
  {
    path: "/article/oopbuy-spreadsheet-guide",
    element: <OopbuySpreadsheetGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;